import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatFraction(text: string | null): string {
  if (!text) return '';
  
  // Regex pour trouver les fractions au format \( \frac{numerator}{denominator} \)
  const fractionRegex = /\\[\s(]*\\frac{(\d+)}{(\d+)}\\[\s)]/g;
  
  return text.replace(fractionRegex, (_, numerator, denominator) => {
    return `<sup>${numerator}</sup>⁄<sub>${denominator}</sub>`;
  });
}